import { useEffect, useState } from 'react';
import { ClientLanguage } from '../types';
import { useNavigate } from "react-router-dom";
import { getClientLang } from '../api';

export function useFetchClientLang() {
  const [clientLang, setClientLang] = useState<ClientLanguage>();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    getClientLang()
    .then(({ data }) => {
      setClientLang(data);
    })
    .catch((err) => {
      console.log(err);
      setError(err);
    })
    .finally(() => setLoading(false))
  }, [navigate]);

  return { clientLang, error, loading };
}